"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      auditActionOptions: [{
        label: '通过审核',
        value: 'APPROVE',
        tag: 'green'
      }, {
        label: '拒绝审核',
        value: 'REJECT',
        tag: 'red'
      }],
      taskStatusOptions: [{
        label: '处理中',
        value: 'PROCESSING',
        tag: 'blue'
      }, {
        label: '成功',
        value: 'SUCCESS',
        tag: 'green'
      }, {
        label: '失败',
        value: 'FAILED',
        tag: 'red'
      }],
      processStatusOptions: [{
        label: '处理中',
        value: 'PENDING',
        tag: 'blue'
      }, {
        label: '成功',
        value: 'SUCCESS',
        tag: 'green'
      }, {
        label: '失败',
        value: 'FAILED',
        tag: 'red'
      }],
      processResultOptions: [{
        label: '审核通过',
        value: 'APPROVED',
        tag: 'green'
      }, {
        label: '审核拒绝',
        value: 'REJECTED',
        tag: 'red'
      }],
      withdrawTypeOptions: [{
        label: '红包余额',
        value: 1,
        tag: 'blue'
      }, {
        label: '金币',
        value: 2,
        tag: 'orange'
      }],
      detailPopup: {
        show: false,
        taskId: '',
        type: ''
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '审核操作',
        prop: 'auditAction',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.auditActionOptions
        }
      }, {
        label: '任务状态',
        prop: 'taskStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.taskStatusOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 230
      }, {
        key: 'taskName',
        visible: true,
        label: "\u4EFB\u52A1\u540D\u79F0",
        width: 200
      }, {
        key: 'auditAction',
        visible: true,
        label: "\u5BA1\u6838\u64CD\u4F5C",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'auditComment',
        visible: true,
        label: "\u5BA1\u6838\u5907\u6CE8",
        width: 200
      }, {
        key: 'taskStatus',
        visible: true,
        label: "\u4EFB\u52A1\u72B6\u6001",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'totalCount',
        visible: true,
        label: "\u63D0\u73B0\u603B\u6570",
        width: 100
      }, {
        key: 'successCount',
        visible: true,
        label: "\u6210\u529F\u6570\u91CF",
        width: 100
      }, {
        key: 'failedCount',
        visible: true,
        label: "\u5931\u8D25\u6570\u91CF",
        width: 100
      }, {
        key: 'createTime',
        visible: true,
        label: "\u63D0\u4EA4\u65F6\u95F4",
        width: 190
      }];
    },
    detailFormData: function detailFormData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '用户ID',
        prop: 'userId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '用户手机',
        prop: 'userPhone',
        defaultValue: '',
        type: 'input'
      }, {
        label: '申请状态',
        prop: 'processStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.processStatusOptions
        }
      }, {
        label: '处理状态',
        prop: 'processResult',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.processResultOptions
        }
      }];
    },
    detailColumns: function detailColumns() {
      return [{
        key: 'withdrawRecordId',
        visible: true,
        label: "\u63D0\u73B0\u8BB0\u5F55ID",
        width: 230
      }, {
        key: 'user',
        visible: true,
        label: "\u7528\u6237",
        width: 200
      }, {
        key: 'withdrawType',
        visible: true,
        label: "\u63D0\u73B0\u65B9\u5F0F",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'withdrawAmount',
        visible: true,
        label: "\u63D0\u73B0\u91D1\u989D",
        width: 100
      }, {
        key: 'processStatus',
        visible: true,
        label: "\u5904\u7406\u72B6\u6001",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'processResult',
        visible: true,
        label: "\u5904\u7406\u7ED3\u679C",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'failReason',
        visible: true,
        label: "\u5931\u8D25\u539F\u56E0",
        width: 100
      }];
    }
  },
  methods: {
    getList: function getList(params) {
      return (0, _user.getWithdrawBatchTaskListApi)(params);
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'auditAction') {
        var target = this.auditActionOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      if (key === 'taskStatus') {
        var _target = this.taskStatusOptions.find(function (item) {
          return item.value === value;
        });
        return _target && _target[valueKey] || defaultValue;
      }
      if (key === 'processStatus') {
        var _target2 = this.processStatusOptions.find(function (item) {
          return item.value === value;
        });
        return _target2 && _target2[valueKey] || defaultValue;
      }
      if (key === 'processResult') {
        var _target3 = this.processResultOptions.find(function (item) {
          return item.value === value;
        });
        return _target3 && _target3[valueKey] || defaultValue;
      }
      if (key === 'withdrawType') {
        var _target4 = this.withdrawTypeOptions.find(function (item) {
          return item.value === value;
        });
        return _target4 && _target4[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    showDetail: function showDetail(row, type) {
      var _this = this;
      this.detailPopup.taskId = row.id;
      this.detailPopup.type = type;
      this.detailPopup.show = true;
      this.$nextTick(function () {
        _this.resetDetailList();
      });
    },
    resetDetailList: function resetDetailList() {
      this.$refs.detailSearchPage && this.$refs.detailSearchPage.resetSearch();
    },
    getDetailList: function getDetailList(params) {
      var func = _user.getWithdrawBatchTaskDetailApi;
      if (this.detailPopup.type === 'success') {
        func = _user.getWithdrawBatchTaskSuccessDetailApi;
      } else if (this.detailPopup.type === 'failed') {
        func = _user.getWithdrawBatchTaskFailedDetailApi;
      }
      return func(_objectSpread(_objectSpread({}, params), {}, {
        taskId: this.detailPopup.taskId
      }));
    }
  }
};